import {h} from 'preact/dist/preact';
import {labels, space, box} from '../styles';
import path from 'ramda/src/path';
import {PageContent, CallRepairsLink, UnitStatus} from '../components';
import {Link} from 'react-router-dom';
import ProductImage from '@components/common/ProductImage';
import {Address} from '@components/common/Address';
import Icon from '@components/common/Icon';

export const EquipmentListHeader = () => (
    <div className={`hidden md:grid md:grid-col-4 ${labels.thead}`}>
        <span className={`lg:w-80 ${space.th}`}>Item name</span> <span className={space.th}>Serial Number</span> <span
        className={`md:w-48 ${space.th}`}>Shipping From</span>
    </div>
);

export const EquipmentListEmpty = () =>
    <PageContent>
        <div className="mt-4">
            <div className="text-center mt-8 max-w-sm mx-auto">
                <h2 className="text-lg font-normal px-8">We can't find any equipment purchases for you.</h2>
                <p className="mt-1">Sorry, there are no equipment items available for your account that we can process
                    repairs for online.</p>
                <p className={`mt-16 ${box.info}`}>
                    If you own a piece of equipment that you need repaired please contact our customer service at <CallRepairsLink />.
                </p>
            </div>
        </div>
    </PageContent>;

// mt-4 rounded bg-near-white border border-transparent border-solid t-border-color t-duration-short hover:border-sky-blue cursor-pointer
export const EquipmentItem = ( {className = '', ...props} ) =>
    <div data-testid="equipment-item"
         className={`py-2 md:p-0 md:grid md:grid-col-4 items-center ${box.divider} ${className}`}>
        <div className={`lg:w-80 ${space.td}`}>
            <div className="flex items-center">
                <ProductImage alt="test" images={props.images} width="64"
                              kitName={props.itemName || props.brand || props.serialId}/>
                <h4 className={`ml-2 ${labels.itemName}`}>{props.itemName || props.brand}</h4>
            </div>
        </div>
        <div className={space.td}>
            <span className="md:hidden mr-2">Serial:</span> <span className={`${labels.data}`}>{props.serialId}</span>
        </div>
        <div className={`${space.td} flex-auto`}>
            <h4 className="md:hidden">Shipping from</h4>
            <Address {...props.address}/>
        </div>
        {props.children}
    </div>;

export const EquipmentResultItem = props => {
    return (
        <EquipmentItem key={props.id} {...props}>
            {(path( ['rmaDetail', 'requestLineStatus'], props ) === 'OPEN')
                ?
                <div className={`${space.td} text-right flex justify-between items-center`}>
                    <UnitStatus {...props.rmaDetail}/>
                    <Link className="block md:mt-4 text-sm" to={`/open-repairs/${props.rmaDetail.requestId}`}>
                        View repair
                    </Link>
                </div>
                :
                <div className={`${space.td} text-right`}>
                {props.isInCart
                    ?
                    <Link to={`/my-equipment/${encodeURIComponent( props.serialId )}`}
                          className="my-2 button success small"> <Icon.ui
                        name="checkmark" className="text-lg" center/> <span className="ml-2">In your cart</span> </Link>
                    :
                    <Link to={`/my-equipment/${encodeURIComponent( props.serialId )}`}
                          className="my-2 button secondary small">Request repair</Link>
                }
            </div>
            }
        </EquipmentItem>
    );
};

export const EquipmentModelDetail = ( {serialId, lotId, className = ''} ) =>
    <dl className={`flex ${className}`}>
        <div>
            <dt className={labels.small}>Serial:</dt>
            <dd className={labels.data}>{serialId}</dd>
        </div>
        <div className="ml-4">
            <dt className={labels.small}>LOT:</dt>
            <dd className={labels.data}>{lotId}</dd>
        </div>
    </dl>;

